import React from 'react';
import { formatDate } from '../../utils/tableUtils';

interface CarEntryHeaderProps {
  voyageCode: string;
  vessel: string;
  pol: string;
  departure: string;
  referenceNumber: number;
  dateOfInput?: string;
  lastEdited?: string;
}

export const CarEntryHeader: React.FC<CarEntryHeaderProps> = ({
  voyageCode,
  vessel,
  pol,
  departure,
  referenceNumber,
  dateOfInput,
  lastEdited
}) => {

  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-700 border border-gray-200 dark:border-gray-600 px-3 py-1.5 rounded-lg">
      <div className="flex items-center justify-between text-sm">
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Voyage:</span>
            <span className="font-semibold text-gray-900 dark:text-gray-100">{voyageCode}</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Vessel:</span>
            <span className="font-semibold text-gray-900 dark:text-gray-100">{vessel}</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">POL:</span>
            <span className="font-semibold text-gray-900 dark:text-gray-100">{pol}</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Departure:</span>
            <span className="font-semibold text-gray-900 dark:text-gray-100">{formatDate(departure)}</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Ref#:</span>
            <span className="font-semibold text-blue-600 dark:text-blue-400">{referenceNumber || 'Auto'}</span>
          </div>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Input:</span>
            <span className="font-medium text-gray-700 dark:text-gray-300">{formatDate(dateOfInput)}</span>
          </div>
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-500 dark:text-gray-400">Changed:</span>
            <span className="font-medium text-gray-700 dark:text-gray-300">{lastEdited ? formatDate(lastEdited) : 'Not yet'}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

